import { DeleteOutlined } from '@ant-design/icons';
import { Button, InputNumber, Space, Table, TableProps, Tag } from 'antd';
import React, { useContext, useEffect, useState } from 'react'
import { PromiseSesionContext } from '../../Machines/ErrorMachine';
import { CartUnit } from '../../Models/CartUnit';
import { Product } from '../../Models/Product';
import { useNavigate } from 'react-router-dom';
import { CartUnitCards } from '../../Models/CartUnitCards';
import { Inventary } from '../../Models/Inventary';

interface DataType {
    key: string;
    name: string;
    age: number;
    address: string;
    tags: string[];
  }
interface Props{
  closeModal?:() => void
}

const DetailCartTable = ({closeModal}:Props) => {
  const {cart, sendCart} = useContext(PromiseSesionContext);
  const {cartCard, sendCartCard} = useContext(PromiseSesionContext);
  const [isMobile, setIsMobile] = useState(false);
  const navigate = useNavigate();


  useEffect(() => {
    const checkIsMobile = () => {
      setIsMobile(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent));
    };
    checkIsMobile();
    window.addEventListener('resize', checkIsMobile);
    return () => window.removeEventListener('resize', checkIsMobile);   
  
  }, []);
  const scrollProps = isMobile ? { x: 100 } : { x: 100, y: 500 };
  const supCart = (inventary:Product)=>{

    sendCart({type: "DISC", data:{producto:inventary}})

  }

  const supCartCard = (inventary:Inventary)=>{

    sendCartCard({type: "DISC", data:{producto:inventary}})

  }

  const editCart = (inventary:Product, quantity:number)=>{

    sendCart({type: "EDIT", data:{producto:inventary, quantity:quantity}})

  }

    const editCartCard = (inventary:Inventary, quantity:number)=>{
  
      sendCartCard({type: "EDIT", data:{producto:inventary, quantity:quantity}})
  
    }

    const columns: TableProps<any>['columns'] = [
        {
          title: 'Imagen',
          key: 'imagen',
          render: (_, record) => <div><img style={{objectFit:"contain", width:"60px"}} src={record.producto.image || record.producto.product.image_url} alt='Logo'></img> </div>,
        },
        {
            title: 'Detalle',
            key: 'precio',
            render: (_, record) => <span>{record.producto.name || (record.producto.product.pokemonCard[0].name +" - "+record.producto.product.pokemonCard[0].sets.name + (`${record.producto.product.card_type!=="rare"? ` - (${record.producto.product.card_type})` : ""}`))}</span>,
  
        },
 
        {
            title: 'Precio',
            key: 'precio',
            render: (_, record) => <span>{(record.producto.discount_price ? record.producto.discount_price :record.producto.price) || record.producto.product.price}$</span>,
  
          },
        {
          title: 'Cantidad',
          dataIndex: 'cantidad',
          render: (_, record) => {
            console.log("record ",record)
            if(record.type==="product"){
                return <InputNumber value={record.cantidad} onChange={(value)=>{editCart(record.producto, value|| 1)}}  min={0} max={record.producto.quantity} />
            }
            else{
              return <InputNumber value={record.cantidad} onChange={(value)=>{editCartCard(record.producto, value|| 1)}}  min={0} max={record.producto.quantity} />
            }
        },
        },
        {
          title: 'SubTotal',
          key: 'subTotal',
          render: (_, record) => (<span>${(record.subTotal).toFixed(1)}</span>),
        },
        {
          title: 'Eliminar',
          key: 'eliminar',
          render: (_, record) => {
            if(record.type==="product"){
              return <DeleteOutlined onClick={()=>{supCart(record.producto)}} style={{cursor:"pointer"}} />
            }
            return <DeleteOutlined onClick={()=>{supCartCard(record.producto)}} style={{cursor:"pointer"}} />
            },
        },
      ];

    
  return (
    <Table<any> bordered={true} scroll={scrollProps} columns={columns} dataSource={[...cart.context.cart.productos, ...cartCard.context.cart.productos]} pagination={false}         locale={{
          emptyText: (
            <span>
              <p style={{ margin: 0 }}>Tu aventura comienza con un carrito vacío. 🗺️ Es la señal para explorar nuestro vasto multiverso de cartas TCG.</p>
              <p style={{ margin: 0, fontSize: '0.9em', color: '#888' }}>
                ¡Encuentra esos singles legendarios, sobres para abrir o colecciones completas que te esperan!
              </p>

              <div>
                <Button type="link" onClick={() =>{navigate("/productos"); if(closeModal)closeModal()}}>Productos</Button>
                <Button type="link" onClick={() =>{navigate("/cartas");if(closeModal)closeModal()}}>Cartas sueltas</Button>
              </div>
            </span>
          ),
        }} />
  )
}

export default DetailCartTable